'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { BackToTopButton } from './BackToTopButton';
import styles from './o-index.module.scss';
import { StickyNav } from './StickyNav';
export const SectionWithScrollHandling = ({ anchorId, children, items, theme })=>{
    const sectionRef = useRef(null);
    const [isStickyNavVisible, setIsStickyNavVisible] = useState(false);
    const [isBackToTopButtonVisible, setIsBackToTopButtonVisible] = useState(false);
    const tickRef = useRef(undefined);
    useEffect(()=>{
        const divRef = sectionRef.current;
        if (!divRef) {
            return;
        }
        const observer = new IntersectionObserver(([entry])=>{
            setIsStickyNavVisible(entry.boundingClientRect.top < -entry.boundingClientRect.height);
        }, {
            root: null,
            threshold: 0
        });
        observer.observe(divRef);
        return ()=>observer.unobserve(divRef);
    }, []);
    useEffect(()=>{
        let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
        const setScrollButtonVisibility = ()=>{
            if (tickRef.current) {
                return;
            }
            tickRef.current = true;
            window.requestAnimationFrame(()=>{
                if (!isStickyNavVisible) {
                    setIsBackToTopButtonVisible(false);
                } else {
                    const scrollTopPosition = window.scrollY || document.documentElement.scrollTop;
                    setIsBackToTopButtonVisible(scrollTopPosition <= lastScrollTop);
                    lastScrollTop = Math.max(scrollTopPosition, 0);
                }
                tickRef.current = false;
            });
        };
        window.addEventListener('scroll', setScrollButtonVisibility);
        return ()=>window.removeEventListener('scroll', setScrollButtonVisibility);
    }, [
        isStickyNavVisible
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("section", {
                className: classNames(styles.section, styles[`section-bg-${theme}`]),
                id: anchorId,
                ref: sectionRef,
                children: children
            }),
            /*#__PURE__*/ _jsx(StickyNav, {
                items: items,
                visible: isStickyNavVisible
            }),
            /*#__PURE__*/ _jsx(BackToTopButton, {
                visible: isBackToTopButtonVisible
            })
        ]
    });
};

//# sourceMappingURL=section-with-scroll-handling.js.map